var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"debounce",rawName:"v-debounce",value:(_vm.valueChanged),expression:"valueChanged"}],staticClass:"w-full form-input form-input-bordered py-2",attrs:{"rows":"1","placeholder":_vm.$t('Enter text'),"readonly":_vm.item.prefillReadOnly === true},domProps:{"value":_vm.item.response}})
}
var staticRenderFns = []

export { render, staticRenderFns }